import React from "react";
import ServicesSection from "../components/ServicesSection";
import Breadcrumb from "../components/Breadcrumb";
import { Helmet } from "react-helmet";

export default function Services() {
  return (
    <>
      <Helmet>
        <title>Services | HealthTech Solutions</title>
        <meta
          name="description"
          content="Explore Healthtech Solutions services including website development, SEO, digital marketing, AI solutions, software development, cloud solutions and IT consulting designed to accelerate business growth."
        />
        <meta
          name="keywords"
          content="AI solutions company, digital marketing agency, SEO services, website development company, software development company, IT consulting services, AI technology solutions"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.healthtechsl.com/services" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Digital & IT Services - Healthtech Solutions"
        />
        <meta
          property="og:description"
          content="Website development, SEO services, AI technology solutions, software development and IT consulting."
        />
        <meta
          property="og:image"
          content="https://healthtechsl.com/images/services-banner.jpg"
        />
        <meta property="og:url" content="https://healthtechsl.com/services" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Digital & IT Services - Healthtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Website development, SEO services, AI technology solutions, software development and IT consulting."
        />
        <meta
          name="twitter:image"
          content="https://healthtechsl.com/images/services-banner.jpg"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Digital Marketing, SEO, Software Development",
            "provider": {
              "@type": "Organization",
              "name": "Healthtech Solutions"
            }
          }
          `}
        </script>

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Healthtech Solutions Pvt Ltd",
            "url": "https://healthtechsl.com",
            "logo": "https://healthtechsl.com/images/logo.png"
          }
          `}
        </script>
        {/* Google Analytics */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-DE4KQ9E1T2"
        ></script>

        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-DE4KQ9E1T2');
            `,
          }}
        />
        {/* Google Tag Manager */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-NJ6DNHM7');
            `,
          }}
        />
        {/* Google Tag Manager (noscript) */}
        <noscript
          dangerouslySetInnerHTML={{
            __html: `
      <iframe 
        src="https://www.googletagmanager.com/ns.html?id=GTM-NJ6DNHM7"
        height="0"
        width="0"
        style="display:none;visibility:hidden">
      </iframe>
    `,
          }}
        />
        {/* FAQ JSON-LD (FIXED) */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "What digital services do you provide?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "We provide SEO, digital marketing, website development, AI solutions, software development, and IT consulting.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Do you offer customized solutions?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, all our services are customized based on business goals, industry, and target audience.",
                  },
                },
                {
                  "@type": "Question",
                  name: "How long does it take to see SEO results?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "SEO results typically start appearing within 3 to 6 months depending on competition and strategy.",
                  },
                },
              ],
            }),
          }}
        />
      </Helmet>

      <Breadcrumb title="Our Services" />
      <ServicesSection />
    </>
  );
}
